import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { CommaSeparatedNumberPipe } from '../../pipes/CommaSeparatedNumberPipe';

@Component({
  selector: 'app-input-rupee',
  templateUrl: './input-rupee.component.html',
  styleUrls: ['./input-rupee.component.css'],
})
export class InputRupeeComponent implements OnInit, OnChanges {
  @Input() value: string;
  @Input() placeholder: string;
  @Output() valueChange: EventEmitter<number>;
  @Input() isBlue: boolean;
  @Input() disabled = false;
  @Input() id: string;
  @ViewChild('rupeeinput') inputText: ElementRef;

  constructor(private commaSeparetedNumberPipe: CommaSeparatedNumberPipe) {
    this.valueChange = new EventEmitter();
  }

  ngOnChanges() {
    // this.valueChange.emit(this.value);
    if (this.value) {
      this.value = this.commaSeparetedNumberPipe.transform(this.value, []);
    }
  }

  ngOnInit() {
    if (this.isBlue === undefined) {
      this.isBlue = true;
    }
    if (!this.placeholder) {
      this.placeholder = '';
    }
  }

  setCaretPosition(ctrl, pos) {
    // Modern browsers
    if (ctrl.setSelectionRange) {
      ctrl.focus();
      ctrl.setSelectionRange(pos, pos);
    
    // IE8 and below
    } else if (ctrl.createTextRange) {
      var range = ctrl.createTextRange();
      range.collapse(true);
      range.moveEnd('character', pos);
      range.moveStart('character', pos);
      range.select();
    }
  }
  updateValue(val) {
    if (val && val != '') {
      var initPosition = 0;
      if(this.inputText){
        if(this.inputText.nativeElement){
          // console.log(this.inputText.nativeElement.selectionStart);
          initPosition = this.inputText.nativeElement.selectionStart;
        }
      }
      const val_str = this.commaSeparetedNumberPipe.reverseTransform(val, []);
      const val_number = parseInt(val_str);
      this.valueChange.emit(val_number);
      if(this.inputText){
        if(this.inputText.nativeElement && this.inputText.nativeElement.setSelectionRange){
          // console.log('hi',initPosition)
          // this.setCaretPosition(this.inputText.nativeElement, initPosition);
        }
      }
    } else {
      this.valueChange.emit(0);
    }
  }
  keyPress(event: any) {
    const pattern = /[0-9\+\-\s\(\) ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  addCommas() {
    // this.value = this.commaSeparetedNumberPipe.transform(this.value, []);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/input-rupee/input-rupee.component.ts